/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PresignedUrl } from '../models/PresignedUrl';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfilePictureService {
    /**
     * Upload a profile picture
     * Uploads the picture of the request body for the executing user.
     *
     * The image will be scaled down or up to match the resolution of
     * 128x128 pixel. Thus, the image can look distorted and an square image cropper
     * is recommended.
     *
     * @returns any Uploaded profile picture
     * @throws ApiError
     */
    public static addProfilePicture({
        requestBody,
    }: {
        /**
         * Profile picture in jpeg or png format as raw bytes
         */
        requestBody: Array<string>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/profile/picture',
            body: requestBody,
            mediaType: 'image/jpeg',
            errors: {
                400: `Invalid image format. Valid image formats: jpeg, png`,
            },
        });
    }
    /**
     * Find presigned url of executing user's profile picture
     * @returns PresignedUrl Presigned url
     * @throws ApiError
     */
    public static findPresignedUrlByUser(): CancelablePromise<PresignedUrl> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/profile/picture/presigned',
            errors: {
                404: `The requested presigned url could not be found. This should never
                occur since default profile picture exist for every user.
                `,
            },
        });
    }
    /**
     * Find presigned url of specified user's profile picture
     * @returns PresignedUrl Presigned url
     * @throws ApiError
     */
    public static findPresignedUrlOfUser({
        target,
    }: {
        /**
         * User id of the target
         */
        target: number,
    }): CancelablePromise<PresignedUrl> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/profile/picture/presigned/{target}',
            path: {
                'target': target,
            },
            errors: {
                403: `User not found or not in the same team`,
                404: `The requested presigned url could not be found. This should never
                occur since default profile picture exist for every user.
                `,
            },
        });
    }
}
